<mat-expansion-panel
  (opened)="panelOpen(true)"
  (closed)="panelOpen(false)"
  [expanded]="panelExpanded"
>
  <mat-expansion-panel-header
    [ngClass]="{
      'expansion-header-expanded': !section?.collapsed,
      'expansion-header-collapsed': section?.collapsed,
    }"
  >
    <mat-panel-title>
      <div class="d-flex justify-content-between align-items-center full-width">
        <h5 class="mb-0">
          {{ section?.name }}
        </h5>
        <status-chips
          [statuses]="statuses"
          *ngIf="!section?.collapsed"
        ></status-chips>
      </div>

      <div *ngIf="section?.collapsed" class="ml-3 full-width">
        <absi-section-signature
          [date]="date"
          [user]="user"
          [catl]="catl"
          [loading]="!section?.wfSignatures"
        ></absi-section-signature>
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <mat-progress-bar
    mode="indeterminate"
    *ngIf="!section?.wfSignatures"
  ></mat-progress-bar>
  <absi-sectionX
    #sectionComponent
    [section]="section"
    [absi]="absi"
    [collapse]="false"
  ></absi-sectionX>
</mat-expansion-panel>
